import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
// Services
import { ServicesComponent } from './pages/services/services.component';
import { Division5Component } from './pages/services/division-5/division-5.component';
import { Division6Component } from './pages/services/division-6/division-6.component';
import { Division7Component } from './pages/services/division-7/division-7.component';
import { Division9Component } from './pages/services/division-9/division-9.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
// Projects
import { ProjectsComponent } from './pages/projects/projects.component';
import { ProjectTemplateComponent } from './pages/projects/project-template/project-template.component';
import { Division10Component } from './pages/services/division-10/division-10.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

export const routes: Routes = [
    { path: '', component: HomeComponent, pathMatch: 'full' },
    { path: 'about-us', component: AboutUsComponent, pathMatch: 'full' },
    { path: 'contact-us', component: ContactUsComponent, pathMatch: 'full' },
    // Old site redirects
    { path: 'contact', redirectTo: 'contact-us', pathMatch: 'full' },
    { path: 'careers', redirectTo: 'contact-us', pathMatch: 'full' },
    { path: 'bid-request', redirectTo: 'contact-us', pathMatch: 'full' },

    // Services
    { path: 'services', component: ServicesComponent, pathMatch: 'full' },
    { path: 'services/division-5', component: Division5Component, pathMatch: 'full' },
    { path: 'services/division-6', component: Division6Component, pathMatch: 'full' },
    { path: 'services/division-7', component: Division7Component, pathMatch: 'full' },
    { path: 'services/division-9', component: Division9Component, pathMatch: 'full' },
    { path: 'services/division-10', component: Division10Component, pathMatch: 'full' },
    // Old site redirects
    { path: 'division-5-metals', redirectTo: 'services/division-5', pathMatch: 'full' },
    { path: 'division-6-wood-plastics', redirectTo: 'services/division-6', pathMatch: 'full' },
    { path: 'division-7-thermal-moisture', redirectTo: 'services/division-7', pathMatch: 'full' },
    { path: 'division-9-finishes', redirectTo: 'services/division-9', pathMatch: 'full' },

    // Projects
    { path: 'projects', component: ProjectsComponent, pathMatch: 'full' },
    { path: 'projects/:id', component: ProjectTemplateComponent },
    // Old site redirects
    { path: 'project-gallery', redirectTo: 'projects', pathMatch: 'full' },
    { path: 'fm-college-schnader-hall', redirectTo: 'projects/f&m-college-schnader-hall', pathMatch: 'full' },
    { path: 'west-hempfield-township-municipal-building', redirectTo: 'projects/west-hempfield-township-municipal-building', pathMatch: 'full' },
    { path: 'lincoln-university-john-miller-dickey-hall', redirectTo: 'projects/lincoln-university', pathMatch: 'full' },
    { path: 'springfield-k-2-early-learning-center', redirectTo: 'projects/springfield-k-2-early-learning-center', pathMatch: 'full' },
    { path: 'alloway-creek-elementary', redirectTo: 'projects/alloway-creek-elementary', pathMatch: 'full' },
    { path: 'spring-creek-elementary-school', redirectTo: 'projects/spring-creek-elementary-school', pathMatch: 'full' },
    { path: 'hambright-elementary-school', redirectTo: 'projects', pathMatch: 'full' },
    { path: 'yuengling-ice-cream-factory', redirectTo: 'projects', pathMatch: 'full' },
    
    // Catch-all redirect
    { path: '**', component: NotFoundComponent }
];
